'use strict';

export class CatalogElement
{

    constructor(offers = {})
    {
        this.offers = offers
        this.init()
    }

    init()
    {
        const instance = this
        const inputsColl = document.querySelectorAll('.js-color-name input[type="radio"]')

        if (inputsColl) {
            inputsColl.forEach((input) => input.addEventListener('change', function (e) {
                e.preventDefault()
                instance.changeColor(input)
            }))
        }
    }

    changeColor(input)
    {
        const instance = this
        let color = input.value
        instance.color = color;
       
        instance.changeSKU()
    }

    changeSKU()
    {
        const instance = this
        let color = this.color

        let parent = document.querySelector('.js-item[data-element-id="'+ this.offers[color].ID_ITEM +'"]')
        let fastOrderHref = document.querySelector('.js-fast-order').getAttribute('href');
        let host = window.location.hostname
        let protocol = window.location.protocol
        let fastOrderUrl = new URL(protocol + host + fastOrderHref);
        fastOrderUrl.searchParams.set('offer-id', this.offers[color].ID); 
        let fastOrderUrlNew = fastOrderUrl.pathname + fastOrderUrl.search
        let basketBtn = parent.querySelector('.js-add-to-basket')

        let quantity = this.offers[color].QUANTITY
        let notAvailable = parent.querySelector('.js-not-available')
        let basketBtns = parent.querySelector('.js-basket-btns')
        
        document.querySelector('.js-img-detail-thumb').setAttribute('src', this.offers[color].DETAIL_PICTURE)
        document.querySelector('.js-img-detail').setAttribute('src', this.offers[color].DETAIL_PICTURE)
        document.querySelector('.js-img-detail').setAttribute('data-src', this.offers[color].DETAIL_PICTURE)
        document.querySelector('.js-price').innerHTML = this.offers[color].PRICE
        document.querySelector('.js-price-old').innerHTML = this.offers[color].PRICE_OLD
        document.querySelector('.js-add-to-basket').setAttribute('data-id', this.offers[color].ID)
        document.querySelector('.js-added').setAttribute('data-id', this.offers[color].ID)
        document.querySelector('.js-fast-order').setAttribute('href', fastOrderUrlNew)

        if (quantity > 0) {
            notAvailable.classList.add('d-none')
            basketBtns.classList.remove('d-none')
            parent.querySelector('.js-fast-order').classList.remove('d-none')
            parent.querySelector('.js-bid').classList.add('d-none')

        } else {
            notAvailable.classList.remove('d-none')
            basketBtns.classList.add('d-none')
            parent.querySelector('.js-fast-order').classList.add('d-none')
            parent.querySelector('.js-bid').classList.remove('d-none')
        }
        instance.getList(basketBtn.getAttribute('data-id'))
    }

    getList(id)
    {
        let instance = this
        $.ajax({
            url: '/local/ajax/basket/get.php',
            method: 'POST',
            data: {id: id},
            success: function(e) {
                if (jQuery.inArray(id, e) !== -1) {
                    $('.js-add-to-basket[data-id="'+id+'"]').addClass('d-none')
                    $('.js-added[data-id="'+id+'"]').removeClass('d-none')
                } else {
                    $('.js-add-to-basket[data-id="'+id+'"]').removeClass('d-none')
                    $('.js-added[data-id="'+id+'"]').addClass('d-none')
                }
                setTimeout(function(){
                    if (e.length > 0){
                        document.querySelector('.cart__count').innerHTML = e.length
                    }
                }, 1000)
            }
        })
    }
}